import React from 'react';

import '../scss/style.scss';

import {CodeInterface} from '../utilities/RM/RM';
import Code from './Code.jsx';
import Input from './Input.jsx';
import Output from './Output.jsx';

export default class App extends React.Component {
  constructor(){
    super();
    this.state={
      code:"",
      result:[],
      input:[],
      output:[],
      memory:{}
    }
    this.rm = new CodeInterface;
  }
  render() {
    return (
      <div>
        <Input inp={this.state.input} hc={(input)=>{this.setState({input:input})}} />
        <Code val={this.state.code} hc={ (value)=>{this.setState({code:value})} }/>
        <button onClick={ (e)=>{this.rm = new CodeInterface; this.rm.setup(this.state.code); let out = this.rm.run([1,2,3,4]); this.rm.show(); this.setState({result:out})} } type="button"> COMPILE AND EXECUTE </button>
        <Output result={this.state.result} />
      </div>);
  }
}

/*
LOAD =11
READ 1
ADD 1
WRITE =5555
WRITE 0
STORE 15
WRITE 15
HALT
*/


// WEBPACK FOOTER //
// ./components/App.jsx